/* ==========================================================================
  tools.js
========================================================================== */

/**
 * Tools variable for the front-end.
 */
var H_Tools = {};
